import { useState, useEffect, useCallback } from "react";
import { employeeService } from "../services/employeeService";

export function useEmployees() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadEmployees = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await employeeService.getEmployees();
      setEmployees(res?.data || []);
    } catch {
      setError("حدث خطأ أثناء جلب بيانات الموظفين");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadEmployees();
  }, [loadEmployees]);

  const addEmployee = async (data) => {
    const res = await employeeService.addEmployee(data);
    await loadEmployees();
    return res;
  };

  const updateEmployee = async (id, data) => {
    const res = await employeeService.updateEmployee(id, data);
    await loadEmployees();
    return res;
  };

  const removeEmployee = async (id) => {
    await employeeService.deleteEmployee(id);
    setEmployees((prev) => prev.filter((emp) => emp.id !== id));
  };

  return { employees, loading, error, loadEmployees, addEmployee, updateEmployee, removeEmployee };
}